import './App.css';
import { Routes, Route } from "react-router";
import Home from './views/page/Home';
import { ThemeProvider } from "next-themes";
import SignIn from './views/page/auth/SignIn';
import SignUp from './views/page/auth/SignUp';
import Navbar from './components/header/Navbar';
import Footer from './components/footer/Footer';
import Test from './components/test/Test';
import { useEffect, useState } from 'react';
import LoadingPage from './views/page/Loading/LoadingPage';
import GuidePage from './views/k_guidePage/GuidePage';
import GdFree from './views/k_guidePage/GdFree';
import AboutPage from './views/page/about/AboutPage';
import AboutDescript from './views/page/about/AboutDescript';
import Contact from './views/k_guidePage/contact/Contact';
import ProtectedRoutes from './service/utils/ProtectedRoutes';
import PaymentForm from './features/payment/PaymentForm';
import ProtectedRoutesDashboard from './service/utils/ProtectedRoutesDashboard';
import HomeDashboard from './dashboard/views/page/Index';
import GdUniversity from './views/k_guidePage/GdUniversity';
import UnivPublic from './views/k_guidePage/gdUniversitys/UnivPublic';
import UnivPrivate from './views/k_guidePage/gdUniversitys/UnivPrivate';
import axios from 'axios';
import { API_BASE_URL } from './config/config';
import KenyaEducationInfo from './views/page/about/KenyaEducationInfo';
import KenyaWorkflow from './views/page/about/KenyaWorkflow';
import { publicRoutes, premiumRoutes } from './routes/routes';

function App() {

  const [isGranted, setIsGranted] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/auth/me`, {
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 200) {
          setIsGranted(true);
        } else {
          setIsGranted(false);
        }
      })
      .catch(() => {
        setIsGranted(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 2000);
  }, []);

  if (isGranted) {

    return (
      <>
        <div>
          {loading ? (
            <>
              <ThemeProvider attribute="class">

                <div className="antialiased mt-10 ">
                  <main className="p-4  items-center justify-center pt-20">
                    <LoadingPage />
                  </main>
                </div>

              </ThemeProvider>
            </>
          ) :
            (
              <ThemeProvider attribute="class">

                <div className="antialiased bg-gray-50 dark:bg-gray-900">
                  <Navbar />
                  <main className="p-1 h-auto pt-20">

                    <Routes>
                      {publicRoutes.map(({ path, element }, i) => (
                        <Route key={i} path={path} element={element} />
                      ))}
                     
                      <Route element={<ProtectedRoutesDashboard />}>
                        <Route path="/mksp/mksp-dashboard-dev" element={<HomeDashboard />} />
                      </Route>
                      
                      <Route element={<ProtectedRoutes />} >
                        {premiumRoutes.map(({ path, element }, i) => (
                          <Route key={i} path={path} element={element} />
                        ))}
                      </Route>
                    </Routes>

                  </main>
                  <Footer />
                </div>

              </ThemeProvider>
            )
          }
        </div>

      </>
    );

  } else {
    return (
      <>
        <div>
          {loading ? (
            <>

              <ThemeProvider attribute="class">

                <div className="antialiased mt-10 ">
                  <main className="p-4  items-center justify-center pt-20">
                    <LoadingPage />
                  </main>
                </div>

              </ThemeProvider>

            </>
          ) :
            (
              <ThemeProvider attribute="class">

                <div className="antialiased bg-gray-50 dark:bg-gray-900">
                  <Navbar />
                  <main className="p-1 h-auto pt-20">
                    <Routes>

                      <Route path="/" element={<Home />} />
                      <Route path="*" element={<SignIn />} />
                      <Route path="/mksp/register" element={<SignUp />} />
                      <Route path="/mksp/about" element={<AboutPage />} />
                      <Route path="/mksp/contact" element={<Contact />} />
                      <Route path="/mksp/test/prod" element={<Test />} />
                      <Route path="/mksp/about-description" element={< AboutDescript />} />
                      <Route path="/mksp/kenya-education-info" element={< KenyaEducationInfo />} />
                      <Route path="/mksp/workflow" element={< KenyaWorkflow />} />

                      {/* Routes for page Guide free */}
                      <Route path="/mksp/guide" element={<GuidePage />} />
                      <Route path="/mksp/guide/all-university" element={<GdFree />} />
                      <Route path="/mksp/guide/university" element={<GdUniversity />} />
                      <Route path="/mksp/guide/university-public" element={<UnivPublic />} />
                      <Route path="/mksp/guide/university-private" element={<UnivPrivate />} />
                      <Route path="/mksp/maxicatch" element={<PaymentForm />} />

                    </Routes>
                  </main>
                  <Footer />
                </div>

              </ThemeProvider>
            )
          }
        </div>

      </>
    );
  }

}

export default App;
